module.exports = __webpack_public_path__ + "flyer_background_palms_2_095-eb5d466c9d76d168b25dc12b8e02f1ec.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Layouts/Backgrounds/flyer_background_palms_2_095.jpg
// module id = 1671
// module chunks = 1